import { configureStore } from '@reduxjs/toolkit'

import {
  persistComparePeriodMiddleware,
  persistCompareShortcutMiddleware,
  persistLinkClickStatsPeriodMiddleware,
  persistLinkClickSelectedKeyMiddleware,
  persistPeriodMiddleware,
  persistQuestionnaireStatsPeriodMiddleware,
} from '../pages/Admin/AdminDashboard/redux/middlewares'
import { persistCurrentAccountMiddleware } from '../user/UserAccountsSlice'

import { errorMiddleware } from './errorMiddleware'
import { rootReducer } from './reducer'

const globalStore = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([
      errorMiddleware,
      persistPeriodMiddleware,
      persistComparePeriodMiddleware,
      persistCompareShortcutMiddleware,
      persistQuestionnaireStatsPeriodMiddleware,
      persistLinkClickStatsPeriodMiddleware,
      persistLinkClickSelectedKeyMiddleware,
      persistCurrentAccountMiddleware,
    ]),
})

export default globalStore

// TODO: circular depency if use RootState or AppDispatch from
// here (we already have RootState in ./reducer.ts, use it please)
export type RootState = ReturnType<typeof globalStore.getState>
export type AppDispatch = typeof globalStore.dispatch
